// src/core/share.ts
import type { Puzzle, RoundResult } from '../types';

export function scoreToEmoji(score: number): string {
  if (score >= 90) return '🟩';
  if (score >= 75) return '🟨';
  if (score >= 60) return '🟧';
  if (score >= 40) return '🟥';
  return '⬛';
}

// Share text format — header, identity line, grid, url:
//
//   Barve №107 — 65/100
//   Atlantic Morning · 🔥 5 day streak
//
//   ⬛🟧🟧🟩🟨
//
//   https://barve.app
//
// • Em-dash between number and score reads as editorial, matching the in-app
//   typographic vocabulary (italic serif masthead, № glyph).
// • Second line carries the Pantone-style puzzle name (conversation hook:
//   "what was yours called?") and the streak when it is 2+ days (momentum).
// • Grid alone on its own line — the canonical viral artifact.
// • Full https:// URL so the link is auto-clickable across iMessage, WhatsApp,
//   Slack, Twitter/X, Discord, and SMS.
export type ShareExtra = { streak: number; dayName: string };

export function shareText(
  puzzle: Puzzle,
  results: RoundResult[],
  total: number,
  extra: ShareExtra,
): string {
  const grid = results.map(r => scoreToEmoji(r.score)).join('');
  const streakClause = extra.streak >= 2 ? ` · 🔥 ${extra.streak} day streak` : '';
  return `Barve №${puzzle.dayNumber} — ${total}/100\n${extra.dayName}${streakClause}\n\n${grid}\n\nhttps://barve.app`;
}
